import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../shared/api-response';

export interface MemberProvisioningData {
  userId: number;
  email: string;
  phone: string;
  primaryAccountId: number;
  primaryAccountNumber: number;
  memberId: string;
  externalAccountNumber: string;
}

@Injectable({ providedIn: 'root' })
export class AdminService {
  private host: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private authHeaders() {
    const token = localStorage.getItem('tokenConnectedUserWSU1234567GHTVB');
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': token });
  }

  ajouterPartenaire(formdata: any) {
    return this.http.post(this.host + "/administration/ajouter/partenaire", formdata, { headers: this.authHeaders() });
  }
  ajouterGestionaire(formdata: any) {
    return this.http.post(this.host + "/administration/ajouter/gestionnaire", formdata, { headers: this.authHeaders() });
  }

  afficherGestionaires() {
    return this.http.get(this.host + "/administration/gestionaires", { headers: this.authHeaders() });
  }

  afficherPartenaires() {
    return this.http.get(this.host + "/administration/partenaires", { headers: this.authHeaders() });
  }

  getSoftPayOperators() {
    return this.http.get(this.host + "/administration/spay/operators", { headers: this.authHeaders() });
  }

  getprimaryAccounts() {
    return this.http.get(this.host + "/administration/primary/accounts", { headers: this.authHeaders() });
  }

  getBussnessAcounts() {
    return this.http.get(this.host + "/administration/bussness/accounts", { headers: this.authHeaders() });
  }

  getprimaryAccount(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/primary/account/" + id, { headers: this.authHeaders() });
  }
  getprimaryAccountAchats(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/primary/accounts/" + id + "/achats", { headers: this.authHeaders() });
  }

  getprimaryAccountDepots(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/primary/accounts/" + id + "/depots", { headers: this.authHeaders() });
  }

  getprimaryAccountRetraits(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/primary/accounts/" + id + "/retraits", { headers: this.authHeaders() });
  }

  getprimaryAccountMensualite(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/primary/accounts/" + id + "/mensualites", { headers: this.authHeaders() });
  }

  getBussnessAcountsUtilisateur(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/affaire/compte/" + id, { headers: this.authHeaders() });
  }
  getBussnessAccountCaissiers(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/affaires/comptes/" + id + "/caissiers", { headers: this.authHeaders() });
  }

  getBussnessAccountAchats(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/affaires/comptes/" + id + "/achats", { headers: this.authHeaders() });
  }

  getBussnessAccountDepots(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/affaires/comptes/" + id + "/depots", { headers: this.authHeaders() });
  }

  getBussnessAccountRetraits(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/affaires/comptes/" + id + "/retraits", { headers: this.authHeaders() });
  }

  getBussnessAccountMensualites(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/affaires/comptes/" + id + "/mensualites", { headers: this.authHeaders() });
  }

  getBussnessAccountCodeRetraits(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/affaires/comptes/" + id + "/code/retraits", { headers: this.authHeaders() });
  }

  utilisateurAddGestionaire(idUtilisateur: any, idgestionaire: any) {
    return this.http.post(this.host + "/administration/utilisateur/add/gestionaire/" + idUtilisateur + "/" + idgestionaire, null, { headers: this.authHeaders() });
  }

  ajouterSoftPayaccount(formdata: any) {
    return this.http.post(this.host + "/administration/ajouter/spay/bank/account/", formdata, { headers: this.authHeaders() });
  }
  ajouterMembre(formdata: any) {
    return this.http.post<ApiResponse<MemberProvisioningData>>(
      this.host + "/administration/utilisateur/ajouter/membre",
      formdata,
      { headers: this.authHeaders() }
    );
  }
  updatesoftPayaccount(id: any, formdata: any) {
    return this.http.put(this.host + "/administration/partenaire/update/information/" + id, formdata, { headers: this.authHeaders() });
  }
  adminUpdateUserPassword(id: any) {
    return this.http.post(this.host + "/administration/utilisateur/update/mot/de/passe/" + id, null, { headers: this.authHeaders() });
  }

  getUtilisateur(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/info/" + id, { headers: this.authHeaders() });
  }

  findGestionaire(id: any) {
    return this.http.get(this.host + "/administration/gestionaire/info/" + id, { headers: this.authHeaders() });
  }

  getUserContactTelephoniqueAdmin(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/contact/Telephonique/" + id, { headers: this.authHeaders() });
  }

  getUserIdentificationAdmin(id: any) {
    return this.http.get(this.host + "/administration/utilisateur/identification/" + id, { headers: this.authHeaders() });
  }

  activationCompteUtilisateur(userid: any) {
    return this.http.post(this.host + "/administration/utilisateur/activation/compte/utilisateur/" + userid, null, { headers: this.authHeaders() });
  }
  desactiverCompteUtilisateur(userid: any) {
    return this.http.post(this.host + "/administration/utilisateur/desactivation/compte/utilisateur/" + userid, null, { headers: this.authHeaders() });
  }

  activerBaccounUser(accountid: any) {
    return this.http.put(this.host + "/administration/utilisateur/activation/compte/affaire/" + accountid, null, { headers: this.authHeaders() });
  }
  desactiverAccountUser(accountid: any) {
    return this.http.put(this.host + "/administration/utilisateur/desactivation/compte/affaire/" + accountid, null, { headers: this.authHeaders() });
  }

  messageActivationImpossible(userid: any, typ: any) {
    return this.http.post(this.host + "/administration/utilisateur/message/activation/compte/impossible/" + userid + "/" + typ, null, { headers: this.authHeaders() });
  }
}
